import React, { useState, useEffect } from "react";
import LoginForm from "../LoginForm";
import RegisterForm from "../RegisterForm";

function Account({ user, setUser }) {
  const [authMode, setAuthMode] = useState("login");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  useEffect(() => {
    if (user?.email) {
      setLoading(true);
      fetch("https://resumefuel.xyz/resume/src/get_user_orders.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: user.email }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data.success) {
            setOrders(data.orders);
          } else {
            console.warn("Failed to fetch orders:", data.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error fetching orders:", err);
        });
    }
  }, [user]);

  if (!user) {
    return (
      <div>
        {authMode === "login" ? (
          <LoginForm
            onLogin={(userData) => {
              setUser(userData);
              setAuthMode("login");
            }}
            onGoToRegister={() => setAuthMode("register")}
          />
        ) : (
          <RegisterForm
            onRegister={(userData) => {
              setUser(userData);
              setAuthMode("login");
            }}
            onGoToLogin={() => setAuthMode("login")}
          />
        )}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div class="login-sec">
        <h2>Welcome, {user.name || user.email}</h2>
        <p>Email: {user.email}</p>

        <button
          onClick={() => window.location.hash = "#/change-password"}
          style={styles.changePasswordButton}
        >
          Change Password
        </button>

        <button onClick={handleLogout} style={styles.logoutButton}>
          Logout
        </button>
      </div>

      <div class="order-sec">
        <h3 style={{ marginTop: 30 }}>Your Orders</h3>
        {loading ? (
          <p>Loading orders...</p>
        ) : orders.length === 0 ? (
          <p>No purchases yet.</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Order ID</th>
                <th style={styles.th}>Amount (USD)</th>
                <th style={styles.th}>Paid At</th>
                <th style={styles.th}>Download</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={index}>
                  <td style={styles.td}>{order.order_id}</td>
                  <td style={styles.td}>{parseFloat(order.amount).toFixed(2)}</td>
                  <td style={styles.td}>
                    {new Date(order.paid_at).toLocaleString()}
                  </td>
                  <td style={styles.td}>
                    {order.resume_url ? (
                      <a
                        href={order.resume_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.downloadLink}
                        download
                      >
                        Download
                      </a>
                    ) : (
                      <span style={{ color: "#aaa" }}>N/A</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
  },
  logoutButton: {
    marginTop: 20,
    padding: "10px 20px",
    fontSize: "1em",
    cursor: "pointer",
  },
  changePasswordButton: {
    marginTop: 20,
    padding: "10px 20px",
    fontSize: "1em",
    backgroundColor: "#ffc107",
    color: "#000",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: 10,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 20,
  },
  th: {
    borderBottom: "2px solid #ccc",
    textAlign: "left",
    padding: "10px",
    backgroundColor: "#f0f0f0",
  },
  td: {
    borderBottom: "1px solid #eee",
    padding: "10px",
  },
  downloadLink: {
    padding: "6px 12px",
    backgroundColor: "#007bff",
    color: "white",
    borderRadius: "4px",
    textDecoration: "none",
  },
};

export default Account;
